import { directionAPI, directionOrdersApi } from '@/api'

export const favoriteCourseSort = (
  item1: ICourseOrder,
  item2: ICourseOrder,
) => {
  const f1 = !!item1?.favorite
  const f2 = !!item2?.favorite
  return f1 === f2 ? 0 : f1 ? -1 : 1
}

export const fetchMyCoursesOrders = async (
  userId: number,
): Promise<ICourseOrder[]> => {
  try {
    const res = await directionOrdersApi.get({
      filter: [`[children_id][eq]=${userId}`, `[is_disabled][eq]=0`, `[status_payment][eq]=1`],    // [status_payment][eq]=1  -- чтобы не отображать курсы которые ни разу небыли оплачены
      expand: ['direction', 'tariff.tariffPeriods', 'tariff.tariffDays', 'class.classUser', 'direction.mediaIcon'],
      pageSize: false,
    })

    const courses = (res?.data?.data as ICourseOrder[]) ?? []

    courses.sort(favoriteCourseSort)

    return courses
  } catch (error) {
    console.error('Ошибка загрузки моих курсов:', error)
    return []
  }
}

export const addCourseToFavorite = async (
  courseId: number,
): Promise<{
  success: boolean
  favorite?: number
}> => {
  try {
    const formDate = new FormData()
    formDate.append('direction_id', courseId?.toString())

    const res = await directionAPI.addFavorite(formDate)

    return res.data
  } catch (error) {
    console.error('Ошибка загрузки моих курсов:', error)
    return {
      success: false,
    }
  }
}
